export default __webpack_public_path__ + "static/media/LionIcon.d2fb3864.svg";